import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { Modal, Form, Button } from 'antd';
import NcmReportForm from '../NcmReportForm/index';
import { ModalProps } from '@/types/ModalProps';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import useFileLoading, { FileType } from '@/hooks/useFileLoading';
import useReportGenerate, { ReportCallback } from '@/hooks/useReportGenerate';
import { ReportNcmFormValues } from '@/core/domain/reports/operational/Report.types';
import { useGenerateNcmReport } from '@/core/domain/reports/operational/Report.hooks';

function NcmReportModal({ visible, handleVisible }: ModalProps) {
  const intl = useIntl();

  const [form] = Form.useForm<ReportNcmFormValues>();
  const mutation = useGenerateNcmReport();
  const { fileLoading, setFileLoading, setFileUnloading, FILE_FORMAT } =
    useFileLoading();
  const report = useReportGenerate();

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);
    try {
      const values = await form.validateFields();

      const obj = {
        ...values,
        format: FILE_FORMAT[format],
      };

      const result = await mutation.mutateAsync(obj);

      if (callback) {
        callback(result);
      }

      handleVisible();
      form.resetFields();
    } catch {}
    setFileUnloading(format);
  };
  return (
    <Modal
      width={660}
      open={visible}
      onCancel={handleVisible}
      title={intl.formatMessage({ id: 'ncm.modal.report.title' })}
      footer={
        <SpaceForButton justifyContent="flex-end">
          <Button
            block
            type="primary"
            onClick={() =>
              handleGenerateReport('REPORT_VIEW', (result) =>
                report.openFile({
                  result,
                  fileName: 'ncm.pdf',
                  fileType: 'application/pdf',
                }),
              )
            }
            key="viewReport"
            loading={fileLoading.REPORT_VIEW}
          >
            <FormattedMessage id="ncm.modal.report.buttons.viewReport" />
          </Button>
          <Button
            block
            type="primary"
            key="PDF"
            onClick={() =>
              handleGenerateReport('PDF', (result) =>
                report.downloadFile({ result, fileName: 'ncm.pdf' }),
              )
            }
            loading={fileLoading.PDF}
          >
            <FormattedMessage id="ncm.modal.report.buttons.pdf" />
          </Button>
          <Button
            block
            type="primary"
            key="CSV"
            onClick={() =>
              handleGenerateReport('CSV', (result) =>
                report.downloadFile({ result, fileName: 'ncm.csv' }),
              )
            }
            loading={fileLoading.CSV}
          >
            <FormattedMessage id="ncm.modal.report.buttons.csv" />
          </Button>
        </SpaceForButton>
      }
    >
      <NcmReportForm form={form} />
    </Modal>
  );
}

export default NcmReportModal;
